import Client from '../../utils/ClientVOIM';
import {
    VIDEO_CALL_END_VISIT_NEW,
    PHYSICIAN,
    GET_VISIT_DETAILS,
    GET_VONAGE_SESSION,
    IM_EDUCATOR,
    VISIT_STATUS,
} from '../../utils/URL';
import { myLog } from '../../utils/Utility';
import { ACTION_TYPES } from '../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../utils/ResponseConstant';

const END_VIDEO_CALL_TIMEOUT = 30000;
const END_VIDEO_CALL_TIMEOUT_MESSAGE =
    'End call request timed out. Please check your connection and try again.';

export function getNewVideoFlowConfig(visitId, callBack) {
    return function (dispatch) {
        Client.get(`${GET_VISIT_DETAILS}/${visitId}`, null, true)
            .then((response) => {
                myLog('====getNewVideoFlowConfig Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.IM_PHYSICIAN.GET_VISIT_INFORMATION,
                        payload: response.response,
                    });
                    dispatch({
                        type: ACTION_TYPES.WHITE_BOARD_OPEN,
                        payload: {
                            isWhiteboardOpen:
                                response.response?.whiteboardResVO?.isWhiteboardOpen || false,
                            sessionType:
                                response.response?.whiteboardResVO?.sessionType ||
                                response.response?.sessionType ||
                                '',
                        },
                    });
                }
            })
            .catch((error) => {
                myLog('====getNewVideoFlowConfig error===????', error);
                callBack(false);
            });
    };
}

/**
 * Get Vonage Session Details - Direct API call for vonage session credentials
 * This is optimized to fetch only the session details needed for joining
 * @param {string} visitId - The visit ID
 * @param {function} callback - Callback function with response
 */
export function getVonageSessionDetails(visitId, callback) {
    return function (dispatch) {
        Client.get(`${GET_VONAGE_SESSION}/${visitId}`, null, true)
            .then((response) => {
                myLog('====getVonageSessionDetails Action response===::::', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    // Dispatch to store the vonage session details
                    dispatch({
                        type: ACTION_TYPES.IM_PHYSICIAN.GET_VONAGE_SESSION_DETAILS,
                        payload: response.response,
                    });
                    callback(response);
                } else {
                    callback(false);
                }
            })
            .catch((error) => {
                myLog('====getVonageSessionDetails error===????', error);
                callback(false);
            });
    };
}

export const endVideoCall = (visitId, isCallSuccessful, isVisitCredit, callback) => {
    return (dispatch) => {
        let isSettled = false;
        const finishEndCall = (action, callbackValue) => {
            if (isSettled) {
                return;
            }

            isSettled = true;
            clearTimeout(timeoutId);
            dispatch(customeAction(action, {}));
            callback(callbackValue);
        };
        const timeoutId = setTimeout(() => {
            myLog('====endVideoCall ==?????timeout', { visitId, timeout: END_VIDEO_CALL_TIMEOUT });
            finishEndCall(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_ERROR, {
                message: END_VIDEO_CALL_TIMEOUT_MESSAGE,
            });
        }, END_VIDEO_CALL_TIMEOUT);

        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_CLICKED, {}));
        Client.put(`${VIDEO_CALL_END_VISIT_NEW}/${visitId}/end`, null, true)
            .then((response) => {
                myLog('====endVideoCall ===::::response', response);
                if (response && response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    finishEndCall(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, true);
                    return;
                }

                finishEndCall(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_ERROR, response || false);
            })
            .catch((error) => {
                myLog('====endVideoCall ==?????error', error);
                finishEndCall(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_ERROR, false);
            });
    };
};

export const endVideoChatClear = () => {
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, {}));
    };
};

export const getVideoChat = (url, visitId, values, callback) => {
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_GET_CHAT_CLICKED, {}));
        Client.getV2(`${url}/${visitId}/chat`, values, true)
            .then((response) => {
                myLog('====getVideoChat ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    if (response.response.messages === null) {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.VIDEO_CALL_SENDER_RECEVIER_IMAGE,
                                response
                            )
                        );
                        callback(response);
                    } else {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.VIDEO_CALL_GET_CHAT_SUCESSS,
                                response.response
                            )
                        );
                        callback(response);
                    }
                } else {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.VIDEO_CALL_SENDER_RECEVIER_IMAGE,
                            response
                        )
                    );
                    callback(response);
                }
            })
            .catch((error) => {
                myLog('====getVideoChat ==?????error', error);
                dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_GET_CHAT_ERROR, {}));
                callback(false);
            });
    };
};

export const startVideoRecord = (visitId, callback) => {
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_START_RECORD_CLICKED, {}));
        Client.post(`${GET_VISIT_DETAILS}/${visitId}/archive/start`, null, true)
            .then((response) => {
                myLog('====startVideoRecord ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.VIDEO_CALL_START_RECORD_SUCESSS,
                            response.response
                        )
                    );
                    callback(response);
                } else {
                    callback(response);
                }
            })
            .catch((error) => {
                myLog('====startVideoRecord ==?????error', error);
                dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_START_RECORD_ERROR, {}));
                callback(false);
            });
    };
};

export const stopVideoRecord = (visitId, callback) => {
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_STOP_RECORD_CLICKED, {}));
        Client.post(`${GET_VISIT_DETAILS}/${visitId}/archive/stop`, null, true)
            .then((response) => {
                myLog('====startVideoRecord ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.VIDEO_CALL_STOP_RECORD_SUCESSS,
                            response.response
                        )
                    );
                }
                callback(response);
            })
            .catch((error) => {
                myLog('====startVideoRecord ==?????error', error);
                dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_STOP_RECORD_ERROR, {}));
                callback(false);
            });
    };
};

export function saveSoap(
    subjective,
    objective,
    plan,
    materialImages,
    handouts,
    visitId,
    visitNoteCompletedStatus,
    isActiveCall,
    callBack
) {
    return function (dispatch) {
        let values = {
            subjective,
            objective,
            plan,
            materialImages,
            handouts,
            visitId,
            visitNoteCompletedStatus,
            isActiveCall,
        };
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.SAVE_SOAP_CLICKED, {}));
        Client.post(PHYSICIAN.UPDATE_SOAP_NOTES, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_PATIENT_SAVE_SOAP,
                        payload: response,
                    });
                    dispatch(
                        customeAction(ACTION_TYPES.PHYSICIAN.SAVE_SOAP_SUCESSS, response.response)
                    );
                }
            })
            .catch((error) => {
                myLog('====saveSoap error===????', error);
                callBack(false);
                dispatch(customeAction(ACTION_TYPES.PHYSICIAN.SAVE_SOAP_ERROR, {}));
            });
    };
}

export function getPatientVisitEncounter(visitId, callBack) {
    return function (dispatch) {
        let values = {
            visitId,
        };
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.GET_ENCOUNTER_CLICKED, {}));
        Client.get(`${PHYSICIAN.GET_SUMMARY}/${visitId}`, values, true)
            .then((response) => {
                myLog('====getPatientVisitEncounter Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.GET_ENCOUNTER_SUCESSS,
                            response.response
                        )
                    );
                    const { assessment, objective, plan, subjective } = response.response.soapNotes;
                    dispatch(updateSoap(subjective, objective, plan, assessment));
                    dispatch(updatePatientHandout(response.response.handouts[0].handout));
                } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch(customeAction(ACTION_TYPES.PHYSICIAN.GET_ENCOUNTER_NOT_FOUND, {}));
                }
            })
            .catch((error) => {
                myLog('====getPatientVisitEncounter error===????', error);
                callBack(false);
                dispatch(customeAction(ACTION_TYPES.PHYSICIAN.GET_ENCOUNTER_ERROR, {}));
            });
    };
}

export function saveSnapShot(visitId, photo, callBack) {
    return function (dispatch) {
        let values = {
            visitId,
            photo,
        };
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.SAVE_SCREEN_SHOT_CLICKED, {}));
        Client.post(PHYSICIAN.SAVE_SCREEN_SHOT, values, true)
            .then((response) => {
                myLog('====saveSnapShot Action response===::::', response);
                callBack(response);
                if (response.response_code === 0) {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.SAVE_SCREEN_SHOT_SUCESSS,
                            response.response
                        )
                    );
                }
            })
            .catch((error) => {
                myLog('====saveSnapShot error===????', error);
                callBack(false);
                dispatch(customeAction(ACTION_TYPES.PHYSICIAN.SAVE_SCREEN_SHOT_ERROR, {}));
            });
    };
}

export const updateSoap = (subjective, objective, plan, assessment) => {
    return (dispatch) => {
        const data = {
            subjective,
            objective,
            plan,
            assessment,
        };
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.SOAP_NOTE_UPDATE, data));
    };
};

export function getVisitDetails(id, callBack) {
    return function () {
        Client.get(`${GET_VISIT_DETAILS}/${id}`, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
}

export function getCallStatus(id, callBack) {
    return function () {
        Client.put(`${PHYSICIAN.CALL_STATUS}${id}/status`, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
}

export const startBroadCast = (visitId, callback) => {
    return () => {
        Client.post(`${IM_EDUCATOR.START_BROADCAST_SESSION}/${visitId}/broadcast`, null, true)
            .then((response) => {
                myLog('====startBroadCast ===::::response', response);
                callback(response);
            })
            .catch((error) => {
                myLog('====startBroadCast ==?????error', error);
                callback(false);
            });
    };
};

export const streamFocusBroadCast = (values, callback) => {
    return () => {
        Client.post(`${IM_EDUCATOR.LAYOUT_CHANGE}`, values, true)
            .then((response) => {
                myLog('====streamFocusBroadCast ===::::response', response);
                callback(response);
            })
            .catch((error) => {
                myLog('====streamFocusBroadCast ==?????error', error);
                callback(false);
            });
    };
};

export const classRoomStudentRemove = (values, callback) => {
    return () => {
        Client.put(
            `${IM_EDUCATOR.REMOVE_CLASSROOM_STUDENT}/${values.studentId}?visitId=${values.visitId}`,
            null,
            true
        )
            .then((response) => {
                myLog('====classRoomStudentRemove ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(true);
                }
            })
            .catch((error) => {
                myLog('====classRoomStudentRemove ==?????error', error);
                callback(false);
            });
    };
};

export const updatePatientHandout = (link) => {
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.PATIENT_HANDOUT_UPDATE, link));
    };
};

export const endStudentBroadCastSession = (callBack) => {
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, {}));
        dispatch({
            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
            payload: false,
        });
        callBack(true);
    };
};

export const customeAction = (action, data) => {
    return {
        type: action,
        payload: data,
    };
};

export const educatorMuteMessage = (values, callback) => {
    return () => {
        const { visitId, isMute } = values;
        Client.post(
            `${IM_EDUCATOR.EDUCATOR_MUTE_MESSAGE_SEND}?visitId=${visitId}&isMute=${isMute}`,
            null,
            true
        )
            .then((response) => {
                myLog('====educatorMuteMessage ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(true);
                }
            })
            .catch((error) => {
                myLog('====educatorMuteMessage ==?????error', error);
                callback(false);
            });
    };
};

export const educatorWhiteboardOpen = (values, callback) => {
    return () => {
        const { visitId, isWhiteboardOpen } = values;
        Client.post(
            `${IM_EDUCATOR.EDUCATOR_WHITEBOARD_OPEN}?visitId=${visitId}&isWhiteboardOpen=${isWhiteboardOpen}`,
            null,
            true
        )
            .then((response) => {
                myLog('====educatorMuteMessage ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(true);
                }
            })
            .catch((error) => {
                myLog('====educatorMuteMessage ==?????error', error);
                callback(false);
            });
    };
};

export const joinInPersonSession = (visitId, callback) => {
    return () => {
        Client.put(`${IM_EDUCATOR.JOIN_IN_PERSON_SESSION}/${visitId}/join-in-person`, null, true)
            .then((response) => {
                myLog('====joinInPersonSession ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(response);
                } else {
                    callback(response);
                }
            })
            .catch((error) => {
                myLog('====joinInPersonSession ==?????error', error);
                callback(false);
            });
    };
};

// Current status of a visit, keyed by its encrypted id. Authorised with the
// service key rather than a cookie, so a third party can call it before they
// are inside the session.
export const getVisitStatus = (visitId, callback) => {
    return () => {
        Client.getWithAuthKey(VISIT_STATUS, { visitId })
            .then((response) => {
                myLog('====getVisitStatus ===::::response', response);
                callback(response);
            })
            .catch((error) => {
                myLog('====getVisitStatus ==?????error', error);
                callback(false);
            });
    };
};

export const anonymousUserDetails = (values, callback) => {
  return () => {
    // Construct the URL with query parameters
    const url = `${IM_EDUCATOR.ANONYMOUS_USER_DETAILS}?firstName=${values.firstName}&lastName=${values.lastName}&userId=${values.userId}&visitId=${values.visitId}`;

    Client.post(url, true) // Use GET request to send data as query parameters
      .then((response) => {
        myLog("====anonymousUserDetails ===::::response", response);
        callback(response);
      })
      .catch((error) => {
        myLog("====anonymousUserDetails ==?????error", error);
        callback(false);
      });
  };
};